module.exports = __webpack_public_path__ + "img/19.824fe8b1.png";